jQuery('img.svg').each(function(){
    var $img = jQuery(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');
    jQuery.get(imgURL, function(data) {
    var $svg = jQuery(data).find('svg');
      if(typeof imgID !== 'undefined') {
        $svg = $svg.attr('id', imgID);
      }
      if(typeof imgClass !== 'undefined') {
        $svg = $svg.attr('class', imgClass+' replaced-svg');
      }
      $svg = $svg.removeAttr('xmlns:a');
        if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
          $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
        }
      $img.replaceWith($svg);
    }, 'xml');
  });

jQuery(document).ready(function() {
  if (jQuery('#blogListing').length) {
    jQuery('#blogListing #wp_pagination .page-numbers').each(function() {
      var text = jQuery(this).text();
      if (text < 10) {
        text = 0 + text;
        jQuery(this).text(text);
      }
    })
  }
});

jQuery(document).ready(function() {
  // if (jQuery(window).width() < 768) {
    if (jQuery('.you-may-also-like .blog-container').length) {
      jQuery('.you-may-also-like .blog-container').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          prevArrow: jQuery('.three-lastest-news-cards.prev'),
          nextArrow: jQuery('.three-latest-news-cards.next'),
          responsive: [
              {
                  breakpoint: 1000,
                  settings: {
                      slidesToShow: 2,
                  }
              },
              {
                  breakpoint: 700,
                  settings: {
                      slidesToShow: 1,
                  }
              }
          ]
      });
    }
  // }
});